"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./flex-embed.css");
var _excluded = ["className", "children", "height", "permitOverflow", "style", "width"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var WrapConditionally = function WrapConditionally(_ref) {
  var children = _ref.children,
    permitOverflow = _ref.permitOverflow;
  if (permitOverflow) {
    return children;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "absoluteSpread"
  }, children);
};

/**
 * A flexible embed component for use with media embeds – such as videos, slideshows, or even
 * images– that need to retain a specific aspect ratio but adapt to the width of their
 * containing element.
 *
 * For images, this is a useful way to prevent layouts from shifting during page
 * load, as the space required by an image will be preserved correctly even in responsive
 * layouts.
 *
 * Use the `height` and `width` props to calculate a ratio based on the dimensions of the content
 * in your embed. With no `height` and `width` set, `FlexEmbed` defaults to a 1:1 (square) ratio.
 *
 * - Based on: http://alistapart.com/article/creating-intrinsic-ratios-for-video
 * - and: https://github.com/suitcss/components-flex-embed
 */
var FlexEmbed = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    children = _ref2.children,
    height = _ref2.height,
    _ref2$permitOverflow = _ref2.permitOverflow,
    permitOverflow = _ref2$permitOverflow === void 0 ? false : _ref2$permitOverflow,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    width = _ref2.width,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var flexEmbedHeight = height > 0 ? height : 100;
  var flexEmbedWidth = width > 0 ? width : 100;
  var heightStyling = {
    paddingBottom: "".concat((flexEmbedHeight / flexEmbedWidth * 100).toFixed(4), "%")
  };
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])(className, {
      relative: !permitOverflow,
      clearfix: permitOverflow
    }),
    ref: ref,
    style: style
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      'block size12of12': !permitOverflow,
      'sb-flexEmbed--height': permitOverflow
    }),
    style: heightStyling
  }), /*#__PURE__*/_react["default"].createElement(WrapConditionally, {
    permitOverflow: permitOverflow
  }, children));
});
FlexEmbed.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  /**
   * The actual height of `children`. `FlexEmbed` will calculate
   * a ratio based on this and `width`.
   * Set to 100 pixels by default.
   */
  height: _propTypes["default"].number,
  /**
   * If the FlexEmbed is for text content (such as a styled heading), you may want
   * to allow the content to overflow the intrinsic aspect ratio you've provided -- just in case!
   * This option uses a float instead of absolute positioning, and may not work correctly
   * when sizing iFrames or padding is applied to the FlexEmbed itself. If possible,
   * provide padding on the children instead.
   */
  permitOverflow: _propTypes["default"].bool,
  /**
   * The actual width of `children`. `FlexEmbed` will calculate
   * a ratio based on this and `height`.
   * Set to 100 pixels by default.
   */
  width: _propTypes["default"].number
} : {};
FlexEmbed.displayName = 'FlexEmbed';
var _default = exports["default"] = FlexEmbed;